<section id="notice-circular-section" class="py-5 my-4">
  <div class="container">
    <div class="row align-items-stretch">
      
      <!-- Left Column: Notice Board -->
      <div class="col-12 col-lg-5 mb-4 mb-lg-0">
        <div class="notice-board-card h-100 shadow-sm d-flex flex-column">
          <div class="notice-board-header px-4 py-3 d-flex align-items-center justify-content-between">
            <h4 class="mb-0 text-white fw-bold text-uppercase">
              <i class="fa-solid fa-bullhorn me-2"></i> Notice Board
            </h4>
            <div class="d-flex align-items-center gap-3">
              <span class="badge bg-warning text-dark text-uppercase fw-bold px-2 py-1" style="font-size: 10px;">Live Updates</span>
              <a routerLink="/info/notifications" class="view-all-link text-white text-decoration-none fw-bold" style="font-size: 13px;">
                View All <i class="fa-solid fa-arrow-right-long ms-1"></i>
              </a>
            </div>
          </div>
          
          <div class="notice-board-body p-4 flex-grow-1 position-relative">
            <marquee behavior="scroll" direction="up" scrollamount="3" onmouseover="this.stop();" onmouseout="this.start();" class="h-100">
              <div class="notice-item p-3 mb-3" *ngFor="let notice of notices" routerLink="/info/notifications" style="cursor: pointer;">
                <div class="d-flex align-items-start gap-3">
                  <div class="notice-icon-box flex-shrink-0 d-flex align-items-center justify-content-center">
                    <i class="fa-regular fa-bell text-orange"></i>
                  </div>
                  <div>
                    <h6 class="mb-1 fw-bold text-dark">{{ notice.title }}</h6>
                    <p class="mb-2 text-secondary" style="font-size: 13px; line-height: 1.45;" *ngIf="notice.description">
                      {{ notice.description }}
                    </p>
                    <span class="notice-date text-muted d-flex align-items-center gap-1">
                      <i class="fa-regular fa-calendar-days text-orange"></i> {{ notice.date }}
                    </span>
                  </div>
                </div>
              </div>
            </marquee>
          </div>
          
          <div class="notice-board-footer p-3 bg-light text-center border-top">
            <small class="text-muted">Hover to pause scrolling</small>
          </div>
        </div>
      </div>
      
      <!-- Right Column: Circulars Table -->
      <div class="col-12 col-lg-7">
        <div class="circulars-card h-100 shadow-sm d-flex flex-column">
          <div class="circulars-header px-4 py-3 d-flex align-items-center justify-content-between">
            <h4 class="mb-0 text-white fw-bold text-uppercase">
              <i class="fa-solid fa-file-invoice me-2"></i> Official Circulars
            </h4>
            <a routerLink="/info/rti-details" class="view-all-link text-white text-decoration-none fw-bold" style="font-size: 13px;">
              View All <i class="fa-solid fa-arrow-right-long ms-1"></i>
            </a>
          </div>
          
          <div class="circulars-body p-4 flex-grow-1 d-flex flex-column justify-content-between">
            <div class="table-responsive">
              <table class="table table-hover align-middle mb-0">
                <thead>
                  <tr>
                    <th scope="col" class="pb-3 text-muted fw-bold text-uppercase" style="font-size: 12px; letter-spacing: 0.05em;">Date</th>
                    <th scope="col" class="pb-3 text-muted fw-bold text-uppercase" style="font-size: 12px; letter-spacing: 0.05em;">Circular Details</th>
                    <th scope="col" class="pb-3 text-muted fw-bold text-uppercase text-end" style="font-size: 12px; letter-spacing: 0.05em; width: 130px;">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let circular of circulars">
                    <td class="py-3">
                      <span class="date-badge fw-semibold">{{ circular.date }}</span>
                    </td>
                    <td class="py-3">
                      <h6 class="mb-0 fw-bold text-dark circular-title">{{ circular.title }}</h6>
                    </td>
                    <td class="py-3 text-end">
                      <a [href]="circular.link" target="_blank" class="btn btn-action btn-sm px-3 py-1.5 fw-bold d-inline-flex align-items-center gap-1.5">
                        <i class="fa" [ngClass]="{
                          'fa-file-pdf': circular.type === 'PDF',
                          'fa-link': circular.type === 'Link',
                          'fa-download': circular.type === 'Download',
                          'fa-book-open': circular.type === 'Brochure'
                        }"></i>
                        {{ circular.type }}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="circulars-info p-3 mt-3 rounded d-flex align-items-center gap-3">
              <div class="info-icon d-flex align-items-center justify-content-center flex-shrink-0">
                <i class="fa-solid fa-circle-info text-orange"></i>
              </div>
              <p class="mb-0 text-muted small" style="line-height: 1.5;">
                All circulars published above are official. Click on the action button to view or download the respective document.
              </p>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</section>
